// extracted by mini-css-extract-plugin
export default {"question":"Question_question__KLr2C"};